import {RefObject} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {borderRadius, calculateRemSize as crs} from "@pg-design/helpers-css-strings";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import standardReview from "../../../assets/standard_review.svg";
import userChoiceIcon from "../../../assets/user_choice.svg";

interface IProps {
    scrollRefElem: RefObject<HTMLDivElement>;
}

export function RankingCreationSteps2023(props: IProps) {
    const {scrollRefElem} = props;

    const boxes: {
        icon: string;
        title: string;
        subTitle: string;
        text: JSX.Element;
        backgroundColor: string;
    }[] = [
        {
            icon: userChoiceIcon,
            title: "I Etap",
            subTitle: "Wybór użytkowników",
            text: (
                <span>
                    Z pomocą użytkowników wybraliśmy nowe inwestycje, które <strong>cieszyły się największą popularnością.</strong> Za pomocą algorytmu
                    sprawdziliśmy, na które projekty klienci m.in. najczęściej wysyłali swoje zapytania i dzwonili do biur sprzedaży.
                    <br />
                    <br />
                    Ze względu na wielkość całej oferty wzięliśmy pod uwagę 10 miast z największą liczbą nowych inwestycji.
                </span>
            ),
            backgroundColor: getThemeVariable("colors.success")
        },
        {
            icon: standardReview,
            title: "II Etap",
            subTitle: "Ocena standardu inwestycji",
            text: (
                <span>
                    Wybrane inwestycje dodatkowo oceniliśmy pod względem standardu wykonania za pomocą <strong>metodologii USI</strong> (Uniwersalnego Standardu
                    Inwestycji), biorącą pod uwagę m.in.:
                    <ul css={contentList}>
                        <li>estetykę elewacji,</li>
                        <li>design części wspólnych,</li>
                        <li>funkcjonalny rozkład mieszkań,</li>
                        <li>zagospodarowanie terenu osiedla.</li>
                    </ul>
                </span>
            ),
            backgroundColor: getThemeVariable("colors.warning")
        }
    ];

    return (
        <div css={creationSteps} ref={scrollRefElem}>
            <Text variant="headline_3" as="h2" align="center">
                Zobacz, jak powstał ranking
            </Text>
            <div css={boxList}>
                {boxes.map(({icon, title, subTitle, text, backgroundColor}, index) => (
                    <Box key={`cb_${index}`} backgroundColor={backgroundColor}>
                        <div css={boxHeader}>
                            <object type="image/svg+xml" data={icon} css={boxIcon} />
                            <div css={boxTitle}>
                                <Text variant="mini_header">{title}</Text>
                                <Text variant="headline_4" as="h3">
                                    {subTitle}
                                </Text>
                            </div>
                        </div>
                        <Text variant="body_copy_1" as="span">
                            {text}
                        </Text>
                    </Box>
                ))}
            </div>
            <Text variant="headline_6" align="center" css={outro} as="p">
                Tak powstało finalne zestawienie, w którym wskazaliśmy 3 laureatów i przyznaliśmy 2 wyróżnienia.
            </Text>
        </div>
    );
}

// Styles
const creationSteps = css`
    display: flex;
    flex-direction: column;
    gap: ${crs(3)};
    justify-content: center;
    align-items: center;
    max-width: 1128px;
    margin: auto;
`;

const boxList = css`
    display: flex;
    flex-direction: column;
    gap: ${crs(3)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        flex-direction: row;
    }
`;

const Box = styled.div<{backgroundColor: string}>`
    ${({backgroundColor}) => css`
        padding: ${crs(2)};
        background-color: ${backgroundColor};
        display: flex;
        flex-direction: column;
        gap: ${crs(2)};
        ${borderRadius(2)};

        @media (min-width: ${getThemeBreakpoint().md}) {
            flex: 1 1 50%;
        }
    `};
`;

const boxHeader = css`
    display: flex;
    gap: ${crs(3)};
    padding: 0 ${crs(1)};
`;

const boxTitle = css`
    display: flex;
    flex-direction: column;
    gap: ${crs(1)};
`;

const boxIcon = css`
    width: ${crs(10)};
    height: ${crs(10)};
`;

const contentList = css`
    margin: 0;
    padding: 0 0 0 ${crs(3)};
`;

const outro = css`
    max-width: 552px;
`;
import {RefObject} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {borderRadius, calculateRemSize as crs} from "@pg-design/helpers-css-strings";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import standardReview from "../../../assets/standard_review.svg";
import userChoiceIcon from "../../../assets/user_choice.svg";

interface IProps {
    scrollRefElem: RefObject<HTMLDivElement>;
}

export function RankingCreationSteps2023(props: IProps) {
    const {scrollRefElem} = props;

    const boxes: {
        icon: string;
        title: string;
        subTitle: string;
        text: JSX.Element;
        backgroundColor: string;
    }[] = [
        {
            icon: userChoiceIcon,
            title: "I Etap",
            subTitle: "Wybór użytkowników",
            text: (
                <span>
                    Z pomocą użytkowników wybraliśmy nowe inwestycje, które <strong>cieszyły się największą popularnością.</strong> Za pomocą algorytmu
                    sprawdziliśmy, na które projekty klienci m.in. najczęściej wysyłali swoje zapytania i dzwonili do biur sprzedaży.
                    <br />
                    <br />
                    Ze względu na wielkość całej oferty wzięliśmy pod uwagę 10 miast z największą liczbą nowych inwestycji.
                </span>
            ),
            backgroundColor: getThemeVariable("colors.success")
        },
        {
            icon: standardReview,
            title: "II Etap",
            subTitle: "Ocena standardu inwestycji",
            text: (
                <span>
                    Wybrane inwestycje dodatkowo oceniliśmy pod względem standardu wykonania za pomocą <strong>metodologii USI</strong> (Uniwersalnego Standardu
                    Inwestycji), biorącą pod uwagę m.in.:
                    <ul css={contentList}>
                        <li>estetykę elewacji,</li>
                        <li>design części wspólnych,</li>
                        <li>funkcjonalny rozkład mieszkań,</li>
                        <li>zagospodarowanie terenu osiedla.</li>
                    </ul>
                </span>
            ),
            backgroundColor: getThemeVariable("colors.warning")
        }
    ];

    return (
        <div css={creationSteps} ref={scrollRefElem}>
            <Text variant="headline_3" as="h2" align="center">
                Zobacz, jak powstał ranking
            </Text>
            <div css={boxList}>
                {boxes.map(({icon, title, subTitle, text, backgroundColor}, index) => (
                    <Box key={`cb_${index}`} backgroundColor={backgroundColor}>
                        <div css={boxHeader}>
                            <object type="image/svg+xml" data={icon} css={boxIcon} />
                            <div css={boxTitle}>
                                <Text variant="mini_header">{title}</Text>
                                <Text variant="headline_4" as="h3">
                                    {subTitle}
                                </Text>
                            </div>
                        </div>
                        <Text variant="body_copy_1" as="span">
                            {text}
                        </Text>
                    </Box>
                ))}
            </div>
            <Text variant="headline_6" align="center" css={outro} as="p">
                Tak powstało finalne zestawienie, w którym wskazaliśmy 3 laureatów i przyznaliśmy 2 wyróżnienia.
            </Text>
        </div>
    );
}

// Styles
const creationSteps = css`
    display: flex;
    flex-direction: column;
    gap: ${crs(3)};
    justify-content: center;
    align-items: center;
    max-width: 1128px;
    margin: auto;
`;

const boxList = css`
    display: flex;
    flex-direction: column;
    gap: ${crs(3)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        flex-direction: row;
    }
`;

const Box = styled.div<{backgroundColor: string}>`
    ${({backgroundColor}) => css`
        padding: ${crs(2)};
        background-color: ${backgroundColor};
        display: flex;
        flex-direction: column;
        gap: ${crs(2)};
        ${borderRadius(2)};

        @media (min-width: ${getThemeBreakpoint().md}) {
            flex: 1 1 50%;
        }
    `};
`;

const boxHeader = css`
    display: flex;
    gap: ${crs(3)};
    padding: 0 ${crs(1)};
`;

const boxTitle = css`
    display: flex;
    flex-direction: column;
    gap: ${crs(1)};
`;

const boxIcon = css`
    width: ${crs(10)};
    height: ${crs(10)};
`;

const contentList = css`
    margin: 0;
    padding: 0 0 0 ${crs(3)};
`;

const outro = css`
    max-width: 552px;
`;
